import { useMemo } from 'react';

import { useCallSummaries } from '@/hooks/useSummary';

export const useQcDetailSummary = ({
  caseId,
  callId,
  programId,
  enabled = true,
}: {
  caseId?: string | null;
  callId?: string | null;
  programId?: string | null;
  enabled?: boolean;
}) => {
  const summariesQuery = useCallSummaries(caseId || null, enabled && !!caseId && !!programId, {
    contextOverride: {
      programId,
    },
  });

  const summary = useMemo(() => {
    if (!callId || !summariesQuery.data || summariesQuery.data.length === 0) {
      return null;
    }

    return summariesQuery.data.find(item => item.call_id === callId) || null;
  }, [callId, summariesQuery.data]);

  return {
    ...summariesQuery,
    summary,
  };
};
